export const NOTISTAK_ADD_QUEUE_KEY = 'examAddToQueue'
export const NOTISTAK_ASSIGN_QUEUE_KEY = 'examAssignToDoctor'
